// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/musterdesign/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const musterdesignDE: PageEntry = {
  id: "post.musterdesign",
  locale: "de",
  slug: "musterdesign",
  seo: {
    title: "Glossar: Musterdesign einfach erklärt | Dietz GmbH",
    description: "Musterdesign bezieht sich auf den Prozess der Gestaltung und Planung von Mustern, die als Vorlagen für die Produktion dienen. Im Kontext von Produkten können Musterdesigns textile ",
  },
  type: "post",
  h1: "Glossar: Musterdesign einfach erklärt",
  intro: "Musterdesign bezieht sich auf den Prozess der Gestaltung und Planung von Mustern, die als Vorlagen für die Produktion dienen. Im Kontext von Produkten können Musterdesigns textile Muster, Grafikdesigns oder auch physische Modelle umfassen. Ein effektives Musterdesign ist entscheidend, um das Endprodukt visuell ansprechend, funktional und den spezifischen Anforderungen entsprechend zu gestalten. Designer verwenden oft spezielle Softwaretools und kreative Prozesse, um Muster zu entwerfen, die als Grundlage für die Musterentwicklung und -erstellung dienen.",
  blocks: [

  ],
};
